<template>
  <div class="dashed-line"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.dashed-line {
  width: 100%;
  height: 2px;
  background-image: linear-gradient(
    to right,
    green 0%,
    green 50%,
    transparent 50%
  );
  background-size: 8px 2px;
  background-repeat: repeat-x;
  /* margin: 25px 0; */
}
</style>